import React from "react";
import GridPaginationLink from "components/source/new_taxonomy/grid-pagination-link";
import { paginateHeadContent } from "helpers/seo-pagination-helper";
import { withQueryParams } from "../hoc/with-query-params";
import PropTypes from "prop-types";

class GridPagination extends React.Component {
  static propTypes = {
    closeProductDrawer: PropTypes.func,
    nextPage: PropTypes.bool,
    onChangePage: PropTypes.func,
    page: PropTypes.number,
    path: PropTypes.string,
    placement: PropTypes.string,
    previousPage: PropTypes.bool,
    queryParams: PropTypes.object,
    totalPages: PropTypes.number,
  };

  onChangePage(path, page) {
    paginateHeadContent(this.props.page, page, this.props.totalPages, this.props.queryParams);

    this.props.onChangePage(path, page);
  }
  render() {
    let className = "grid-pagination label";

    if (this.props.placement) {
      className += " grid-pagination-" + this.props.placement;
    }

    return (
      <div className="grid-pagination-container">
        <p className={className}>
          <GridPaginationLink
            closeProductDrawer={this.props.closeProductDrawer}
            path={this.props.path}
            page={this.props.page - 1}
            active={this.props.previousPage}
            direction="previous"
            onChangePage={(path, page) => {
              this.onChangePage(path, page);
            }}
          />
          <span className="grid-pagination-current">{this.props.page + " / " + this.props.totalPages}</span>
          <GridPaginationLink
            closeProductDrawer={this.props.closeProductDrawer}
            path={this.props.path}
            page={this.props.page + 1}
            active={this.props.nextPage}
            direction="next"
            onChangePage={(path, page) => {
              this.onChangePage(path, page);
            }}
          />
        </p>
      </div>
    );
  }
}

export default withQueryParams()(GridPagination);
